import { useMutation } from '@tanstack/react-query';

import type { Portfolio } from 'src/api-sdk';
import type { MutationHookOptions } from 'src/types/global';
import { useAPI } from 'src/util/use-api';

type PortfolioUpdateParams = {
  portfolioId: string;
  data: Partial<Portfolio>;
};

export const useUpdatePortfolio = (
  options: MutationHookOptions<Portfolio | undefined> = {}
) => {
  const { API } = useAPI();

  return useMutation({
    mutationFn: async ({ portfolioId, data }: PortfolioUpdateParams) => {
      return (
        await API?.portfoliosAPI.portfoliosPartialUpdate({
          portfolioId,
          patchedPortfolioRequest: data,
        })
      )?.data;
    },

    ...options,
  });
};
